import { Component, Input, output } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { NumberStepperComponent } from "../../../global/Stepper/stepper.component";
import { FourInputs } from "../../cockpitDesigner/designerComponents/fourInputs/four-inputs.component";
import { IfourInputs } from "../cockpitDesigner.models";


export interface ElementProperties {
  width: number;
  height: number;
  lockAspectRatio: boolean;
 
  columns: number;
  gap: number;
 
  marginTop: number;
  marginRight: number;
  marginBottom: number;
  marginLeft: number;
 
  paddingTop: number;
  paddingRight: number;
  paddingBottom: number;
  paddingLeft: number;
 
  backgroundColor: string;
  opacity: number;
  borderRadius: number;
}

type SpacingMode = 'margin' | 'padding';
type SpacingSide = 'Top' | 'Right' | 'Bottom' | 'Left';
const defaultProperties: ElementProperties = {
  width: 320,
  height: 180,
  lockAspectRatio: false,
  columns: 2,
  gap: 16,
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 20,
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  backgroundColor: '#ffffff',
  opacity: 100,
  borderRadius: 0,
};

@Component({
  selector : 'app-designer-cockpit-css-properties',
  templateUrl: 'designerCSSPropertiesForm.html',
  styleUrl: 'designerCSSPropertiesForm.css',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSliderModule,
    NumberStepperComponent,
    FourInputs
  ],
})

export class  DesignerCSSPropertiesForm {

 @Input() properties: ElementProperties = { ...defaultProperties };

 propertiesChange = output<ElementProperties>();
 columnsChange = output<number>();
 readonly columnOptions = [1, 2, 3, 4, 6, 12];

  spacingMode: SpacingMode = 'margin';
  linkMargin = false;
  linkPadding = false;
 
  private readonly aspectRatio = { value: 1 };
 
  update(): void {
    this.propertiesChange.emit(this.properties);
  }

  onColumnChange(value: number){
    this.properties.columns = value;
    this.columnsChange.emit(value);
  }
 
  onWidthChange(value: number): void {
    if (this.properties.lockAspectRatio) {
      this.properties.height = Math.round(value / this.currentRatio());
    }
    this.properties.width = value;
    this.update();
  }

  handleSpacingChange(value: IfourInputs) {
  
    if(this.spacingMode === 'margin') {
      this.propertiesChange.emit({
      ...this.properties,
      marginLeft: value.left,
      marginRight: value.right,
      marginBottom: value.bottom,
      marginTop: value.top
    })

    
    }
     if(this.spacingMode === 'padding') {

      console.log('new paddig values', value)
      this.propertiesChange.emit({
      ...this.properties,
      paddingLeft: value.left,
      paddingRight: value.right,
      paddingBottom: value.bottom,
      paddingTop: value.top
    })
    } 
  }
 
  onHeightChange(value: number): void {
    console.log('number', value)
    if (this.properties.lockAspectRatio) {
      this.properties.width = Math.round(value * this.currentRatio());
    }
    this.properties.height = value;
    console.log("should now emit", this.properties)
    this.propertiesChange.emit({...this.properties})
  }
 
  toggleAspectLock(): void {
    this.properties.lockAspectRatio = !this.properties.lockAspectRatio;
    if (this.properties.lockAspectRatio && this.properties.height) {
      this.aspectRatio.value = this.properties.width / this.properties.height;
    }
    this.update();
  }
 
  private currentRatio(): number {
    return this.aspectRatio.value || 1;
  }
 
  setSpacingMode(mode: SpacingMode): void {
    console.log('toggling', mode)
      console.log('properties', this.properties)
    this.spacingMode = mode;
  }
 
  toggleSpacingLink(): void {
    if (this.spacingMode === 'margin') {
      console.log('toggling', this.spacingMode)
      console.log('properties', this.properties)
      this.linkMargin = !this.linkMargin;
    } else {
      this.linkPadding = !this.linkPadding;
    }
  }
 
  get spacingLinked(): boolean {
    return this.spacingMode === 'margin' ? this.linkMargin : this.linkPadding;
  }
 
  getSpacing(side: SpacingSide): number {
    const key = `${this.spacingMode}${side}` as keyof ElementProperties;
    return this.properties[key] as number;
  }
 
  setSpacing(side: SpacingSide, value: number): void {
    const prefix = this.spacingMode;
 
    if (this.spacingLinked) {
      (['Top', 'Right', 'Bottom', 'Left'] as SpacingSide[]).forEach((s) => {
        (this.properties as any)[`${prefix}${s}`] = value;
      });
    } else {
      (this.properties as any)[`${prefix}${side}`] = value;
    }
 
    this.update();
  }

}
